// extracted by mini-css-extract-plugin
export default {"bars":"TnSidebarButton_bars__xu8Jp","bar":"TnSidebarButton_bar__8UCEP","bar-fullwidth":"TnSidebarButton_bar-fullwidth__M-Tz7"};